module.exports = __webpack_public_path__ + "static/media/rondas.b8e8e926.jpg";